<template v-slot:footer>
  <footer :class="['footer', $style.customFooter]">
    <div class="container">
      <p :class="$style.footerContent">
        {{ this.year }} © JBI
        <template v-if="version">
          | Version {{ versionReleaseNumber }} Build {{ versionBuildNumber }}
        </template>
      </p>
    </div>
  </footer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _VersionJson from '../../../public/assets/versions/version.json';

interface Version {
  version: {
    release: number | string;
    build: number;
  };
}

const version = _VersionJson ? (_VersionJson as Version).version : undefined;

@Component({})
export default class Footer extends Vue {
  public year = new Date().getFullYear();

  get version() {
    return version;
  }
  get versionReleaseNumber() {
    return version ? version.release : undefined;
  }
  get versionBuildNumber() {
    return version ? version.build : undefined;
  }
}
</script>

<style lang="scss" module>
.customFooter {
  background-color: #fbfbfb;
  text-align: center;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.footerContent {
  color: #9f9f9f;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}
</style>
